import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './axios'
import './protos'
import './settings'


createApp(App).use(router).mount('#app')